import {Injectable} from '@angular/core';
import {DataCoreService} from '@dabnet-kamu/libs/ui';
import {TemTaahhutService} from '../ctl-tem-taahhut.service';

@Injectable()
export class Service {

  constructor(private dataCoreService: DataCoreService, private service: TemTaahhutService) {
  }

  getData(control: any) {
    const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
    dataSource.select([]);
    const filterArr = [];
    if (this.service.period) filterArr.push(['Donem', '=', this.service.period]);
    if (this.service.kurumsalKod) filterArr.push(['KurumsalKod', '=', this.service.kurumsalKod]);
    if (this.service.controlCondition) {
      this.service.controlCondition.forEach((item: any) => {
        filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
      });
    }
    if (filterArr.length > 0) dataSource.filter(filterArr)
    return dataSource;
  }


}
